export const serverUrl: string =
  process.env.REACT_APP_SERVER_URL || 'http://localhost:1337';
export const appId: string = process.env.REACT_APP_APP_ID || 'mahidol';
